.mermaid {
  margin: 16px 0;
}
